<div class="d-flex flex-column align-items-center">
  <h4 class="text-center text-uppercase kit-serie elsa-title-font">{{serie}}</h4>
  <h3 class="text-center text-uppercase kit-name elsa-title-font">{{name}}</h3>
  <picture>
    <img class="product-img object-fit-cover" [src]="img" [alt]="name">
  </picture>
  <span class="kit-phi-info font-weight-bold">{{phiInfo}}</span>
  <a title="Elsa - Kit" appEmptyTitle class="btn btn-gray btn-elsa text-uppercase"
     [routerLink]="Paths.Kit | page:[slug] | localize"
     [queryParams]="getQueryParams('label_product' | translate)">{{'label_details' | translate}}</a>
</div>
